import type { Commit, Dispatch } from 'vuex';
import type { RootState } from '@/store';

interface State {
  isModalShown: boolean;
}

const state = (): State => ({
  isModalShown: false,
});

const actions = {
  toggleModal(
    { commit, dispatch, rootState }: { commit: Commit; dispatch: Dispatch; rootState: RootState },
    isShown: boolean
  ) {
    commit('TOGGLE_MODAL', isShown);

    if (rootState.isMobileScreen) {
      dispatch('enableScroll', undefined, { root: true });
    }
  },
};

const mutations = {
  TOGGLE_MODAL(state: State, isShown: boolean) {
    state.isModalShown = isShown;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
